






























































import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";
import { isAudioFile, isImageFile, isVideoFile } from "@/lib/fileHelpers";
import AudioPlayerController from "@/components/AudioPlayerController";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseImage from "@/components/BaseImage";
import PlayButton from "@/components/PlayButton";

export default defineComponent({
  name: "UploadedFileItem",
  components: { BaseIconButton, BaseIcon, AudioPlayerController, PlayButton, BaseImage },
  props: {
    file: { type: File, required: true },
  },
  setup(props, { emit }) {
    const player = ref();
    const videoSource = ref();
    const isVideoPlaying = ref(false);
    const mediaSrc = ref("");
    const imageSrc = ref("");
    const isVideo = computed(() => isVideoFile(props.file));
    const isImage = computed(() => isImageFile(props.file));
    const isAudio = computed(() => isAudioFile(props.file));
    const getAudioVideoSrc = (file: File) => {
      const newObjectUrl = URL.createObjectURL(file) as string;
      const oldObjectUrl = mediaSrc.value;
      if (oldObjectUrl && oldObjectUrl.startsWith("blob:")) {
        mediaSrc.value = "";
        URL.revokeObjectURL(oldObjectUrl);
      }
      mediaSrc.value = newObjectUrl;
    };
    const getImageSrc = (imageFile: File) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(imageFile);
      fileReader.onload = event => {
        if (event && event.target) {
          imageSrc.value = event.target.result as string;
        }
      };
    };

    const onPlayPause = (status: boolean) => {
      isVideoPlaying.value = status;
    };

    const playVideo = () => {
      const el = getElement<HTMLVideoElement>(player.value);
      el.play();
    };

    onMounted(() => {
      if (isImage.value) {
        getImageSrc(props.file);
      }
      if (isVideo.value) {
        getAudioVideoSrc(props.file);
        const el = getElement<HTMLVideoElement>(player.value);
        el.load();
        el.addEventListener("loadedmetadata", () => {
          emit("fileDuration", { name: props.file.name, duration: el.duration * 1000 });
        });
      }
      if (isAudio.value) {
        getAudioVideoSrc(props.file);
      }
    });
    return {
      player,
      videoSource,
      isVideo,
      isImage,
      imageSrc,
      isAudio,
      mediaSrc,
      isVideoPlaying,
      playVideo,
      onPlayPause,
    };
  },
});
